import type { AppSubjects } from "@lbcrm-api/casl/app.subjects";
import { Params } from "react-router-dom";
import { Action } from "src/casl/Action";

export interface RouteCan {
    i: Action;
    a: AppSubjects | ((params: Readonly<Params<string>>) => AppSubjects);
}

/** Passes when any one of its checks does, for a screen that took over from two */
export interface RouteCanAny {
    any: RouteCan[];
}

export const routeCan = (i: Action, a: RouteCan["a"]) => ({ can: { i, a } satisfies RouteCan });

export const routeCanAny = (...any: RouteCan[]) => ({ can: { any } satisfies RouteCanAny });
